// Breakpoints reactivity with Tailwind and VueJS
// https://dev.to/f3ltron/tailwind-vuejs-breakpoint-reactivity-2al7

import TailwindScreens from "@/../../tailwind.screens"
import { debounce, mapValues } from "lodash-es"
import { reactive } from "vue"

const screens = mapValues(TailwindScreens, screen => screen.replace("px", ""))

const sync = (breakpoints) => {
  const width = window.innerWidth

  breakpoints.name = (() => {
    /* istanbul ignore next */
    switch (true) {
      case width >= screens.sm && width < screens.md:
        return "sm"
      case width >= screens.md && width < screens.lg:
        return "md"
      case width >= screens.lg && width < screens.xl:
        return "lg"
      case width >= screens.xl && width < screens["2xl"]:
        return "xl"
      case width >= screens["2xl"]:
        return "2xl"
    }
  })()

  breakpoints.sm = breakpoints.name === "sm"
  breakpoints.md = breakpoints.name === "md"
  breakpoints.lg = breakpoints.name === "lg"
  breakpoints.xl = breakpoints.name === "xl"
  breakpoints["2xl"] = breakpoints.name === "2xl"

  breakpoints.smAndUp = width >= screens.sm
  breakpoints.mdAndUp = width >= screens.md
  breakpoints.lgAndUp = width >= screens.lg
  breakpoints.xlAndUp = width >= screens.xl
  breakpoints["2xlAndUp"] = width >= screens["2xl"]

  breakpoints.smAndDown = width < screens.md
  breakpoints.mdAndDown = width < screens.lg
  breakpoints.lgAndDown = width < screens.xl
  breakpoints.xlAndDown = width < screens["2xl"]

  return breakpoints
}

export const breakpoints = reactive(sync({}))

/* istanbul ignore next */
window.addEventListener("resize", debounce(() => sync(breakpoints), 100), false)
